import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { SuitabilityWrapper } from '@/components/dealCatalog-page/allocator-page/table/cell/suitabilityDetails';
import Suitability from '@/components/investors-page/investorDetailsPage/tabs/beginAllocationTab/table/suitability';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import guid from '@/shared/utils/guid';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { columns } from '../../constants';
import { IInvestmentEntity } from '../../types';

interface MobileTableProps {
  listInvestmentEntity: IInvestmentEntity[];
  openMobileModal: (data: IInvestmentEntity, modalType: string) => void;
  openInvestorDetailsPage: ({ investorId, entityId, isGroup }: { investorId: string; entityId?: string; isGroup?: boolean }) => Promise<void>;
}

const MobileTable = ({ listInvestmentEntity, openMobileModal, openInvestorDetailsPage }: MobileTableProps) => {
  const TableRow = ({ el }: { el: IInvestmentEntity }) => {
    return (
      <MobileTableRowWrap key={guid()}>
        <MobileRow>
          <MobileRowTitle>{columns[0].title}</MobileRowTitle>
          <MobileRowValue isRedirect onClick={() => openInvestorDetailsPage({ investorId: el?.family.id, entityId: el.id, isGroup: !!el.groupId })}>
            {el.entityName}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[1].title}</MobileRowTitle>
          <HouseholdMobileRowValue>
            <HouseholdName onClick={() => openInvestorDetailsPage({ investorId: el?.family.id })}>{el?.family.name}</HouseholdName>
            {el?.advisor ? el?.advisor?.initials || `${el?.advisor?.firstName} ${el?.advisor?.lastName}` : ''}
          </HouseholdMobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[2].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip zIndex={1000}>{el.overallCapacity}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[3].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip zIndex={1000}>{el.assetClassCapacity}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[4].title}</MobileRowTitle>
          <MobileRowValue onClick={() => openMobileModal(el, 'suitability')}>
            <SuitabilityWrapper>
              <Suitability suitability={el.suitability === 'Suitable' ? 'Meets Criteria' : el.suitability} width="100" />
            </SuitabilityWrapper>
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[5].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip zIndex={1000}>{el.investor_interest[0]?.amount}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {listInvestmentEntity.length ? (
        listInvestmentEntity.map((el, index) => {
          return <TableRow el={el} key={index} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const HouseholdMobileRowValue = styled(MobileRowValue)`
  display: flex;
  flex-direction: column;
`;

const HouseholdName = styled.div`
  font-weight: 600;
  color: ${themeVar('font.action')};
`;
